export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    SortOrder["NO_ORDER"] = "no_order";
})(SortOrder || (SortOrder = {}));
//# sourceMappingURL=index.js.map